import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

//Components
import {
    SidePanel,
    SidePanelBody,
    SidePanelFooter,
    Button,
    Select
} from '@gpstrackit/gtc-react-controls';
import { Grid } from '@mui/material';
// import TagFilter from 'Modules/.common/components/TagFilter';

// Actions
import {
    openModalAssetAdvancedFilters,
    assetSearchAssetSubtype,
    assetSearchEntityLists,
    reset
} from './redux/slice';

// Styles
import './index.scss';
const AdvancedFilters = ({ tableRef, formData, setFormData, initialState, applyChanges, clearSelection, hasFilters, savePreferences }) => {


    const dispatch = useDispatch()
    const { messages } = useIntl()

    // Redux States
    const { open, loading, entityLists, loadingEntityLists, loadingAssetSubtypes, assetSubtypes } = useSelector((state) => state.manageAssetAdvancedFiltersRedux);

    useEffect(() => {
        if (open) {
            dispatch(assetSearchEntityLists({}));
            dispatch(assetSearchAssetSubtype({}));
        }
    }, [open])

    useEffect(() => {
        return () => {
            dispatch(reset())
        }
    }, [])

    const clearFilters = () => {
        setFormData(initialState);
        savePreferences([{ key: "assetType", value: null }, { key: "assetSubtype", value: null }, { key: "tags", value: [] }])
        clearSelection?.();
        tableRef.refresh({});
    }

    return (
        <SidePanel
            isOpen={open}
            onToggle={() => dispatch(openModalAssetAdvancedFilters({ open: !open }))}
            style={{ zIndex: 2, width: '320px', transform: 'translateX(320px)' }}
            contentStyle={{ overflowY: "hidden" }}
            classSidePanel={hasFilters() ? "work-order-advanced-filters-available" : ""}
        >
            <SidePanelBody>
                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                    <Grid item>
                        <h2 style={{ margin: 0 }}>
                            {messages['asset_tab_advancedFilters_title']}
                        </h2>
                        <span
                            className='btn-link'
                            onClick={clearFilters}
                        >
                            {messages['asset_tab_advancedFilters_clearAll']}
                        </span>
                    </Grid>
                </Grid>
                <div style={{ width: 270, marginTop: 10 }}>
                    <Select
                        id="assetType"
                        label={messages['asset_tab_advancedFilters_assetType']}
                        type="text"
                        placeholder={messages['asset_tab_advancedFilters_assetType']}
                        textField="label"
                        valueField="entityId"
                        isClearable
                        isSearchable
                        options={entityLists.filter((item) => item?.entityName === "AssetType") || []}
                        value={formData?.assetType || null}
                        onChange={(value) => {
                            setFormData({ ...formData, assetType: value })
                            savePreferences([{ key: "assetType", value: value }])
                        }}
                        isLoading={loadingEntityLists}
                        style={{ marginBottom: 10 }}
                    />
                    <Select
                        label={messages['asset_tab_advancedFilters_assetSubType']}
                        id="assetSubtype"
                        type="text"
                        placeholder={messages['asset_tab_advancedFilters_assetSubType']}
                        textField="name"
                        valueField="id"
                        isClearable
                        isSearchable
                        value={formData?.assetSubtype || null}
                        options={assetSubtypes || []}
                        onChange={(value) => {
                            setFormData({ ...formData, assetSubtype: value })
                            savePreferences([{ key: "assetSubtype", value: value }])
                        }}
                        isLoading={loadingAssetSubtypes}
                    />
                    <div style={{ marginTop: 10 }}>
                        {/* <TagFilter
                            id="tags"
                            showCreateOption={false}
                            showUntagged={false}
                            showSelectAll={false}
                            label={messages["dynamicFormsDesign_tags"]}
                            placeholder={messages["search"]}
                            values={formData?.tags || []}
                            inline={false}
                            multiple={true}
                            onChange={(values) => {
                                setFormData({ ...formData, tags: values })
                                savePreferences([{ key: "tags", value: values }])
                            }}
                        /> */}
                    </div>
                </div>
            </SidePanelBody>
            <SidePanelFooter>
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <Button
                        isDisabled={loading}
                        style={{ marginRight: 8 }}
                        onClick={() => dispatch(reset({ open: false }))}
                        variant="secondary"
                    >
                        {messages["cancel"]}
                    </Button>
                    <Button
                        isDisabled={loading}
                        onClick={() => applyChanges()}
                        variant="primary"
                    >
                        {messages["apply"]}
                    </Button>
                </div>
            </SidePanelFooter>
        </SidePanel>
    )
}

export default AdvancedFilters
